import globalData from '../globalData'

/**汇率 */
class Rate{
  constructor(country, rate){
    this.country = country        // 国家缩写
    this.rate = rate              // 汇率
  }
}

/**输入框类 */
class InputBoX{
  constructor(type, name, data, obj = { decimal: 0, pla: '', html: false, isDisable: true, show: true }){
    /**输入框类型 */
    this.type = type
    /**输入框名称 */
    this.name = name
    /**输入框绑定数据 */
    this.data = data
    /**输入框详情 */
    this.html = obj.html ? globalData[this.data + 'InputHtml'] : ''
    /**保留小数点后几位 */
    this.decimal = obj.decimal ? obj.decimal : 0
    /**type 如果是 select 的话，对应的子项 */
    this.array = this.type === 'select' ? globalData[this.data + 'InputOptions'] : []
    /**是否显示详情 */
    this.showDetail = false
    /**是否禁用 */
    this.isDisable = obj.isDisable
    /**是否显示该输入框 */
    this.show = obj.show == undefined ? true : obj.show
    /**提示数据 */
    this.pla = obj.pla
    /**数据是否刷新 */
    this.isRefresh = false
    /**定时器 */
    this.timer = null
  }
}

/**城市类 */
class City{
  constructor(name, id, obj = { provinceName: '', provinceId: '' }) {
    this.name = name
    this.id = id
    this.provinceName = obj.provinceName
    this.provinceId = obj.provinceId
  }
}

/**表头类 */
class TableHead{
  constructor(name, prop, width, obj = { disable: false }) {
    this.name = name
    this.prop = prop
    this.width = width
    this.disable = obj.disable === undefined ? false : obj.disable
  }
}

/**汇总数据类 */
class Summary{
  constructor(name, data, obj = { unit: '', preUnit: '' }) {
    this.name = name
    this.data = data
    this.unit = obj.unit
    this.preUnit = obj.preUnit
  }
}

/**菜单选项  */
class MenuOption{
  constructor(name, id) {
    this.name = name
    this.id = id
  }
}

/**搜索数据 */
class SearchData{
  constructor() {
    this.page = 1
    this.text = ''
  }
}

/**处理数据返回结果 */
class DealResult{
  constructor(code, info){
    this.code = code
    this.info = info
  }
}


export { Rate, InputBoX, City, TableHead, Summary, MenuOption, SearchData, DealResult }
